import CryptoJS from "crypto-js";

const SECRET_KEY =
  process.env.REACT_APP_SECRET_ACCESS_KEY ||
  "fallback-secret-key-32-characters";

export const setEncryptedItem = (key, value) => {
  try {
    const stringifiedValue = JSON.stringify(value);
    const encrypted = CryptoJS.AES.encrypt(
      stringifiedValue,
      SECRET_KEY
    ).toString();
    localStorage.setItem(key, encrypted);
  } catch (e) {
    console.error(`Encryption failed for key ${key}:`, e.message);
  }
};

export const getDecryptedItem = (key) => {
  const encrypted = localStorage.getItem(key);
  if (!encrypted) return null;
  try {
    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  } catch (e) {
    console.error("Decryption failed:", e.message);
    return null;
  }
};

export const removeItem = (key) => {
  localStorage.removeItem(key);
};

export const clearEncryptedStorage = (preserveKeys = []) => {
  const preserved = {};
  preserveKeys.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value) preserved[key] = value;
  });

  localStorage.clear();

  Object.entries(preserved).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
};
